import Player from '@vimeo/player';

export const initGlobal = () => {
    /**
     * Show-more-function
     */
    const heroShowMore = () => {
        const heroReadMoreToggle = document.querySelector(".hero__show-more-toggle") as HTMLButtonElement;
        const heroTextContainer = document.querySelector(".hero__text") as HTMLParagraphElement;

        if (heroReadMoreToggle && heroTextContainer) {
            heroReadMoreToggle.addEventListener("click", () => {
                heroReadMoreToggle.classList.toggle("active");
                heroTextContainer.classList.toggle("active");
            });
        }
    }

    heroShowMore();


    const textShowMore = () => {

        const heroReadMoreToggles = document.querySelectorAll(".text-image-block__show-more-toggle");


        heroReadMoreToggles.forEach((heroReadMoreToggle) => {

            const heroTextContainer = heroReadMoreToggle.closest(".text-image-block").querySelector(".text-image__text") as HTMLParagraphElement;

            if (heroReadMoreToggle && heroTextContainer) {
                heroReadMoreToggle.addEventListener("click", () => {
                    heroReadMoreToggle.classList.toggle("active");
                    heroTextContainer.classList.toggle("active");
                });
            }
        });
    }

    textShowMore();


    const contactShowMore = () => {
        const toggleButtons = document.querySelectorAll(".contacts-puff-block__show-more-toggle");
        const textContainers = document.querySelectorAll(".contacts-puff-block__contact-puff--text");

        toggleButtons.forEach((button, index) => {
            button.addEventListener("click", () => {
                button.classList.toggle("active");
                textContainers[index].classList.toggle("contacts-puff-block__contact-puff--text-active");

                // Loop through all buttons to apply styling
                //toggleButtons.forEach((btn, idx) => {
                //    if (idx !== index) {
                //        (btn as HTMLElement).style.margin = "0"; // Apply styling to all buttons except the clicked one
                //    }
                //    if (idx == index) {
                //        (btn as HTMLElement).style.margin = "auto"; // Apply styling to all buttons except the clicked one
                //    }
                //});
            });
        });
    }

    contactShowMore();


    const tableShowMore = () => {
        const heroReadMoreToggle = document.querySelector(".text-box__header--show-more-toggle") as HTMLButtonElement;
        const heroTextContainer = document.querySelector(".text-box__table") as HTMLTableElement;

        if (heroReadMoreToggle && heroTextContainer) {
            heroReadMoreToggle.addEventListener("click", () => {
                heroReadMoreToggle.classList.toggle("text-box__header--active");
                heroTextContainer.classList.toggle("text-box__table--active");
                console.log("test");
            });
        }
    }

    tableShowMore();

    const initializeImageVideoControls = () => {
      
        const imageVideosArray = document.querySelectorAll(".text-image-block");

        imageVideosArray.forEach((imageVideoControls) => {
            const playPauseButton = imageVideoControls.querySelector(".text-image-block__play-pause-button") as HTMLButtonElement;

            if (playPauseButton) {
                playPauseButton.addEventListener("click", () => {
                    playPauseButton.classList.toggle("active");

                   
                    const videos = imageVideoControls.querySelectorAll(".text-image-block__video");

               
                    videos.forEach((video) => {
                        const videoElement = video as HTMLVideoElement; 

                        if (videoElement.paused) {
                            videoElement.play();
                        } else {
                            videoElement.pause();
                        }
                    });
                });
            }
        });
    }

    initializeImageVideoControls();

    const initializeImagesVideoControls = () => {

        const imageVideosArray = document.querySelectorAll(".text-images-block");

        imageVideosArray.forEach((imageVideoControls) => {
            const playPauseButton = imageVideoControls.querySelector(".text-images-block__play-pause-button") as HTMLButtonElement;

            if (playPauseButton) {
                playPauseButton.addEventListener("click", () => {
                    playPauseButton.remove();
                    
                    const videos = imageVideoControls.querySelectorAll(".text-images-block__video");
                    
                    videos.forEach((video) => {
                        const videoElement = video as HTMLVideoElement;
                        
                        if (videoElement.paused) {
                            videoElement.play();
                            videoElement.controls = true;
                        } 
                    });
                });
            }
        });
    }

    initializeImagesVideoControls();

    const initializeVimeoPlayer = () => {
        const iframes = document.querySelectorAll('[data-player]');
        
        iframes.forEach((iframe) => {
            const player = new Player(iframe as HTMLIFrameElement);
            const block = iframe.closest('.text-image-block'); // Adjust selector if needed
            
            if (!block) return;
            
            const btn = block.querySelector('#togglePlayPause') as HTMLButtonElement;
            const controlContainer = block.querySelector('.text-image-block__controls');
            const playLabel = controlContainer?.getAttribute('data-playvideo');
            const pauseLabel = controlContainer?.getAttribute('data-pausevideo');
            
            if (!btn) return;

            // Pause the video when it loads
            player.pause();
            
            btn.addEventListener('click', function () {
                player.getPaused().then(function(paused: boolean) {
                    if (paused) {
                        player.play();
                        btn.ariaLabel = pauseLabel || '';
                        btn.title = pauseLabel || '';
                    } else {
                        player.pause();
                        btn.ariaLabel = playLabel || '';
                        btn.title = playLabel || '';
                    }
                });
            });
        });
    }

    initializeVimeoPlayer();
}


